import { findIndex, propEq } from 'ramda';
import { AxiosError } from 'axios';

import { AccountGroupData } from '../../../../Procedures/Reports/type';

export const findDuplicateAccountGroups = (
  currentAccountGroup: AccountGroupData,
  accountGroups: readonly AccountGroupData[] | undefined
) => {
  return findIndex(propEq('name', currentAccountGroup.name))(
    accountGroups ?? []
  );
};

export const getErrorMessageKey = (
  err: AxiosError<{ error: { code: number; message: string } }>
) => {
  switch (err.response?.data?.error?.message) {
    case 'account.group.delete_with_dependencies':
      return 'deleteWithDependencies';
    default:
      return 'somethingWentWrong';
  }
};
